import type React from "react";
import {memo} from "react";
import {useParams} from "react-router-dom";

import {useWipLevelV2} from "~/api/hooks/useWipLevelV2";
import AppHeader from "~/component/common/AppHeader";

import DeleteSelectionButton from "./buttons/DeleteSelectionButton";
import DuplicateSelectionButton from "./buttons/DuplicateSelectionButton";
import PlayTestLevelButton from "./buttons/PlayTestLevelButton";
import EditMenuModalButton from "./edit-menu/EditMenuModalButton";
import GameObjectModalButton from "./object-selector/ObjectSelectorModalButton";

const EditLevel: React.FC = memo(() => {
  const {id} = useParams<{id: string}>();
  const {data: level} = useWipLevelV2({id});

  return (
    <div className="flex flex-col w-screen min-h-screen text-white relative pointer-events-none">
      <AppHeader title={level?.name} parentPath="/create" />
      <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 z-50 pointer-events-auto flex justify-center gap-2">
        <GameObjectModalButton />
        <DeleteSelectionButton />
        <DuplicateSelectionButton />
        <PlayTestLevelButton />
        <EditMenuModalButton />
      </div>
    </div>
  );
});

export default EditLevel;
